import React, { Component } from "react";
import {
  Dialog,
  DialogHeader,
  DialogFooter,
  DialogFooterButton
} from "@cdk-uip/react-dialog";

export default class DeleteOrganizationDialog extends Component {
  constructor(props) {
    super(props);
  }

  deleteOrganization = e => {
    this.props.deleteOrganization(this.props.entity);
    this.props.onClose(e);
  };

  render() {
    const { open, onClose, entity } = this.props;
    return (
      <Dialog open={open} onCancel={onClose}>
        <DialogHeader>
          Are you sure you want to delete organization ?
        </DialogHeader>
        <DialogFooter>
          <DialogFooterButton onClick={e => this.deleteOrganization(e)}>
            Yes
          </DialogFooterButton>
          <DialogFooterButton onClick={onClose}>No</DialogFooterButton>
        </DialogFooter>
      </Dialog>
    );
  }
}
